var ui = fpUtil.getNamespace('ui', fp);
ui.Loading = function (options) {
    if(_.isString(options)) {
        options = {
            template: options
        }
    }
    options = _.getObject(options);

    var loading;
    if(options.appendTo) {
        loading = $(options.appendTo).data('fp.ui.Loading');
    }

    if(!loading) {
        options.template = options.template || fp.ui.renderTemplate('component/0/animated-loading.html', null, null, true);

        this.options = options;
        this.__showCount = 0;
        this.$element = $(options.template).appendTo(fp.__$freshop);
        this.id = _.uniqueId();
        loading = this;
    }

    if(options.showOnInstantiate) loading.show();

    return loading;
};

$.extend(ui.Loading.prototype, {
    show: function (options) {
        if(options) {
            options = _.getObject(options);

            if (options instanceof Element || fpUtil.isJQuery(options)) {
                var appendTo = options;
                options = {
                    appendTo: appendTo
                };
            }

            options = $.extend(this.options, options);
        }
        else options = this.options;

        options.appendTo = $(options.appendTo);

        //don't show loader if no element to append to
        if (!options.appendTo.length) return;

        if (options.css) this.$element.css(options.css);
        // if (!options.appendTo.length) options.appendTo = fp.__$freshop;
        if(!options.containerClass) options.containerClass = 'fp-animated-loading-container';
        if(options.enableEvents) {
            options.containerClass += ' fp-animated-loading-container-events';
        }

        options.appendTo.data('fp.ui.Loading', this);
    
        this.__showCount++;
    
        //if(fp.loaded) {
        //    fp.logStack('show');
        //    fp.log('show', this, options.appendTo[0]);
        //}
    
        var self = this;
        clearTimeout(this.__startDelayTimeout);
        var show = function(){
            if (self.__showCount <= 0) return;
            if(options.disableIfShown && self.$element.filter(':visible').length) {
                return;
            }

            var $appendTo = self.options.appendTo;
            if($appendTo[0] != fp.__$freshop[0]) {
                $appendTo.addClass(options.containerClass);
            }
            self.$element.appendTo($appendTo).show();
        };

        if(options.startDelay) this.__startDelayTimeout = _.delay(show, options.startDelay);
        else show();
    
        if(fpUtil.isPromise(options.promiseHide)) {
            options.promiseHide.always(function() {
                self.hide();
            });
        }
    },
    hide: function (force) {
        if(!this.__showCount) return;
        if (force) this.__showCount = 0;
        else if (this.__showCount > 0) this.__showCount--;
    
        //fp.log('hide', this.__showCount, force);
        //if(fp.loaded) {
        //    fp.logStack('hide');
        //    fp.log(this.__showCount, this);
        //}
        if (this.__showCount > 0) return;
    
        this.options.appendTo
            .removeClass(this.options.containerClass)
            .removeData('loading fp.ui.Loading');

        if(this.options.destroyOnHide) this.destroy();
        else this.$element.appendTo(fp.__$freshop).hide();
    },
    isShown: function () {
        return this.__showCount > 0;
    },
    destroy: function() {
        clearTimeout(this.__startDelayTimeout);

        if(fpUtil.isJQuery(this.options.appendTo)) {
            this.options.appendTo
                .removeClass(this.options.containerClass)
                .removeData('loading fp.ui.Loading');
        }

        this.$element.remove();
    }
});

